import Link from 'next/link'
import Image from 'next/image'
import styled from 'styled-components'

const HeroBanner = ({ hero_banner: item }: any) =>
  <Container> {/*  style={{ background: item.bg_color ? item.bg_color : "" }} */}
    <Content>
      {item.banner_title && (
        <Title>{item.banner_title}</Title>)}
      {item.banner_description &&
        <Typography>
          {item.banner_description}
        </Typography>}
      {item.call_to_action.title && item.call_to_action.href &&
        <Link href={item.call_to_action.href}>
          <a className="btn tertiary-btn">{item.call_to_action.title}</a>
        </Link>}
    </Content>
    {item.banner_image &&
      <Image
        alt={item.banner_image.filename}
        src={item.banner_image.url}
        width={539}
        height={410} />}
  </Container>

export default HeroBanner

const Container = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  padding: 2rem;
  img {
    filter: grayscale(1)
  }
`

const Content = styled.div``

const Title = styled.h1``

const Typography = styled.p``